import { useTranslation } from 'react-i18next';

import { Form, Pagination } from '@arco-design/web-react';
import type { FormInstance } from '@arco-design/web-react';

import { RadioList } from '@/components';

import { useNodeListColumns } from '../hooks/useNodeListColumns';
import type { BareMetalNodesBlockOptions, BareMetalNodesPaths } from '../types';
import { type PhysicalNodeRecord, applyPhysicalNodeSelection } from '../utils/physicalNodeMeta';

const FormItem = Form.Item;

interface PhysicalNodeListProps {
  form: FormInstance;
  paths: BareMetalNodesPaths;
  disabled: boolean;
  nodes: PhysicalNodeRecord[];
  loading: boolean;
  selectedNode: PhysicalNodeRecord;
  pagination: { page: number; limit: number; total: number };
  onSelectNode: (record: PhysicalNodeRecord) => void;
  onPageChange: (page: number, pageSize: number) => void;
  options?: BareMetalNodesBlockOptions;
}

/** 非计价模式：物理节点 RadioList 与分页 */
export function PhysicalNodeList({
  form,
  paths,
  disabled,
  nodes,
  loading,
  selectedNode,
  pagination,
  onSelectNode,
  onPageChange,
  options,
}: PhysicalNodeListProps) {
  const { t } = useTranslation();
  const columns = useNodeListColumns();

  return (
    <>
      <FormItem field={paths.bmsNode} disabled={disabled} rules={[{ required: true, message: t('common:required.field') }]}>
        <RadioList
          disabled={disabled}
          columns={columns}
          data={nodes}
          loading={loading}
          value={selectedNode?.key}
          style={{ height: 'max-content' }}
          onChange={(value: string, record: PhysicalNodeRecord) => {
            const nodeName = applyPhysicalNodeSelection(form, paths, record);
            onSelectNode(record);
            options?.onChange?.(nodeName, record);
          }}
        />
      </FormItem>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Pagination
          total={pagination.total || nodes.length}
          current={pagination.page}
          pageSize={pagination.limit}
          showTotal
          onChange={onPageChange}
        />
      </div>
    </>
  );
}
